import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, useReducer } from 'react';
import { twMerge } from 'tailwind-merge';
import { Checkbox, RadioInput } from '../../../atoms';
import { TableBodyCell } from './TableBodyCell';
import { TableCell } from './TableCell';
const tableRowStateReducer = (state, action) => {
    switch (action) {
        case 'mouseEnter':
            return Object.assign(Object.assign({}, state), { hovered: true });
        case 'mouseLeave':
            return Object.assign(Object.assign({}, state), { hovered: false });
        case 'mouseDown':
            return Object.assign(Object.assign({}, state), { clicked: true });
        case 'mouseUp':
            return Object.assign(Object.assign({}, state), { clicked: false });
        default:
            return state;
    }
};
const tableRowStateClassName = (state) => state.clicked && state.hovered
    ? 'bg-grey-light-active'
    : state.hovered
        ? 'bg-grey-light-hover'
        : '';
const initialState = { hovered: false, clicked: false };
export const TableRow = (props) => {
    const { isLastRow, row, index, enableRowSelection, getRowClassName, onRowClick, onRowMouseEnter, onRowMouseLeave, renderSubComponent, enableMultiRowSelection, rightPinnedColumn, scrollState, isLoading, } = props;
    const [rowState, dispatch] = useReducer(tableRowStateReducer, initialState);
    const cellActionProps = {
        onMouseEnter: () => {
            dispatch('mouseEnter');
            if (!rowState.hovered) {
                handleRowMouseEnter(row);
            }
        },
        onMouseLeave: (e) => {
            dispatch('mouseLeave');
            if (rowState.hovered) {
                const rowIndex = e.relatedTarget instanceof HTMLElement &&
                    typeof e.relatedTarget.dataset.rowIndex !== 'undefined'
                    ? +e.relatedTarget.dataset.rowIndex
                    : -1;
                if (rowIndex === index)
                    return;
                handleRowMouseLeave(row);
            }
        },
        onMouseDown: () => dispatch('mouseDown'),
        onMouseUp: () => dispatch('mouseUp'),
    };
    const handleRowClick = (row) => {
        if (!onRowClick)
            return;
        onRowClick(row);
    };
    const handleRowMouseEnter = (row) => {
        if (!onRowMouseEnter)
            return;
        onRowMouseEnter(row);
    };
    const handleRowMouseLeave = (row) => {
        if (!onRowMouseLeave)
            return;
        onRowMouseLeave(row);
    };
    const rowStateClassName = onRowClick ? tableRowStateClassName(rowState) : '';
    const rowClassName = getRowClassName === null || getRowClassName === void 0 ? void 0 : getRowClassName(row, rowState);
    const className = twMerge(onRowClick ? 'cursor-pointer' : '', rowStateClassName, rowClassName);
    return (_jsxs(Fragment, { children: [enableRowSelection ? (_jsx(TableBodyCell, Object.assign({ pinnedPosition: false, rowIndex: index, index: -1, isLastRow: isLastRow, className: twMerge('pl-3', rowStateClassName, rowClassName), testId: `${index}_rowSelectCheckbox`, scrollState: scrollState }, cellActionProps, { children: enableMultiRowSelection ? (_jsx(Checkbox, { disabled: isLoading, checked: row.getIsSelected(), onChange: row.getToggleSelectedHandler() })) : (_jsx(RadioInput, { disabled: isLoading, checked: row.getIsSelected(), onChange: row.getToggleSelectedHandler(), padded: false })) }))) : null, row.getVisibleCells().map((cell, cellIndex) => (_jsx(TableCell, Object.assign({ isLoading: isLoading, rightPinnedColumn: rightPinnedColumn, rowIndex: index, index: cellIndex, pinnedPosition: cell.column.getIsPinned(), cell: cell, isLastRow: isLastRow, className: className, testId: cell.id, onRowClick: () => handleRowClick(row), scrollState: scrollState }, cellActionProps), cell.id))), row.getIsExpanded() ? (_jsx("div", { className: "col-span-full", children: renderSubComponent ? renderSubComponent({ row }) : null })) : null] }, row.id));
};
//# sourceMappingURL=TableRow.js.map